import React from 'react';
import { IconsPros } from './types';

/**
 * Html Icon component
 *
 * @returns JSX.ELEMENT
 */
export const HtmlIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M13.7,8.36s-1.92,1.93-2.12,2.11a.58.58,0,0,1-.76,0,.46.46,0,0,1,0-.71L12.59,8,10.82,6.25a.46.46,0,0,1,0-.71.58.58,0,0,1,.76,0c.2.18,2.12,2.11,2.12,2.11a.48.48,0,0,1,0,.71Zm-4-3L7.29,11a.36.36,0,0,1-.46.19l-.21-.08a.33.33,0,0,1-.19-.44L8.81,5a.36.36,0,0,1,.46-.19l.21.08A.33.33,0,0,1,9.67,5.36ZM5.19,9.76a.46.46,0,0,1,0,.71.58.58,0,0,1-.76,0c-.2-.18-2.12-2.11-2.12-2.11a.48.48,0,0,1,0-.71S4.23,5.73,4.43,5.54a.58.58,0,0,1,.76,0,.46.46,0,0,1,0,.71L3.42,8ZM2.56,0A2.5,2.5,0,0,0,0,2.44V13.56A2.5,2.5,0,0,0,2.56,16H13.44A2.5,2.5,0,0,0,16,13.56V2.44A2.51,2.51,0,0,0,13.44,0Z" />
    </svg>
  );
};
